import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getStyles, localizePrice } from '../../../shared/utility';

import Button from '../../../components/UI/Button/Button';
import Icon from '../../../components/UI/Icon/Icon';
import Dots from '../../../components/UI/Loading/Dots/Dots';

import localStyles from './CartButton.scss';
const styles = getStyles(localStyles);

const cartButton = (props) => {

    const loading = (props.items.loading || props.pricing.loading);
    const hasItems = props.items.data && !loading && !props.items.error;
    const hasPrice = props.pricing.data && !loading && !props.pricing.error;

    const items = hasItems ? props.items.data.cartItems.length : !props.items.error ? <Dots bullets max={1} timeout={600} /> : null;
    const price = hasPrice ? localizePrice(
        props.pricing.data.totalPayment.priceIncludingVat - props.pricing.data.totalPayment.discountIncludingVat,
        props.pricing.data.totalPayment.currencyCode,
        props.locale
    ) : 0;

    const itemCount = items !== null ? (
        <span className={styles('cartbutton__count')}>
            <Icon icon={'cart-open'} modifiers={['large']}/>
            <span className={styles('cartbutton__count__number', 'small', 'align--center')}>
                {items}
            </span>
        </span>
    ) : null;


    return (
        <Fragment>
            {/* mobile button */}
            <Button classes={styles('mobile-only', 'w--500')} modifiers={['square']} href={'/cart/'}>
                {itemCount}
            </Button>
            {/* portrait button */}
            <Button classes={styles('cartbutton', 'w--500', 'portrait')} modifiers={['primary', 'm']} href={'/cart/'}>
                {itemCount}
                {price ? <span className={styles('cartbutton__price')}>{price}</span> : null}
            </Button>
        </Fragment>
    );
};

cartButton.propTypes = {
    // properties
    items: PropTypes.object,
    pricing: PropTypes.object,
    
    locale: PropTypes.string.isRequired
};

const mapStateToProps = state => {
    return {
        locale: state.global.localization.locale
    };
};

export default connect(mapStateToProps, null)(cartButton);



// WEBPACK FOOTER //
// ./src/containers/Cart/CartButton/CartButton.js